import { pb } from './pocketbase';

export const getCurrentStudentInfo = async () => {
  if (!pb.authStore.isValid) return null;

  const user = pb.authStore.model;
  let student = null;
  const expand = 'formation,company,contract_id';
  const options = {
    expand,
    fields: 'id,first_name,last_name,email,phone,status,inscription_at,file_status,formation,company,contract_id,expand.formation.id,expand.formation.exact_title_of_qualification,expand.formation.title,expand.company.name,expand.contract_id.type'
  };

  try {
    student = user.student_id ?
      await pb.collection('students').getOne(user.student_id, options) :
      await pb.collection('students').getFirstListItem(`user_ref="${user.id}"`, options);
    
    // Débogage des données de formation
    console.log('Données étudiant récupérées:', {
      studentId: student.id,
      formationId: student.formation,
      hasExpand: !!student.expand,
      formationExpand: student.expand?.formation,
      formationKeys: student.expand?.formation ? Object.keys(student.expand.formation) : [],
      formationTitle: student.expand?.formation?.qualification_title
    });
  } catch (e) {
    console.error('Error fetching student in account.service.js:', e);
  }

  return { user, student };
};

export const getCurrentCompanyInfo = async () => {
  if (!pb.authStore.isValid) return null;

  const user = pb.authStore.model;
  let company = null;
  const expand = 'tutor_id';

  try {
    if (user.company_id) {
      company = await pb.collection('companies').getOne(user.company_id, { expand });
    }
  } catch (e) {
    console.error('Error fetching company in account.service.js:', e);
  }

  return { user, company };
};

export const updateCurrentUser = async (userData) => {
  if (!pb.authStore.isValid) throw new Error('Utilisateur non connecté');
  return await pb.collection('users').update(pb.authStore.model.id, userData);
};

export const updateUserPassword = async (oldPassword, newPassword, confirmPassword) => {
  if (!pb.authStore.isValid) throw new Error('Utilisateur non connecté');

  const userId = pb.authStore.model.id;

  try {
    return await pb.collection('users').update(userId, {
      oldPassword: oldPassword,
      password: newPassword,
      passwordConfirm: confirmPassword
    });
  } catch (error) {
    console.error('Erreur PocketBase lors de la mise à jour du mot de passe:', error);

    if (error.response && error.response.code === 400 && error.response.data) {
      if (error.response.data.oldPassword) {
        const newError = new Error('Ancien mot de passe incorrect');
        newError.status = 400;
        throw newError;
      }
      if (error.response.data.password || error.response.data.passwordConfirm) {
        const newError = new Error('Le nouveau mot de passe est invalide ou ne correspond pas.');
        newError.status = 400;
        throw newError;
      }
    }

    const newError = new Error('Une erreur est survenue lors de la mise à jour du mot de passe.');
    newError.status = error.status || error.response?.code || 500;
    throw newError;
  }
};

export const updateStudentInfo = async (studentId, studentData) => {
  if (!pb.authStore.isValid) throw new Error('Utilisateur non connecté');
  if (!studentId) throw new Error('ID étudiant manquant');
  
  return await pb.collection('students').update(studentId, studentData);
};

